// Service worker cache names, shared between the SW (sw.ts) and the app (so the client can clear
// the offline API cache on an auth change without the name drifting out of sync).
// BUMP the app-shell version whenever an UNHASHED public/ asset changes in place (activate()
// deletes caches not in the keep-set, evicting the stale copies for every returning visitor).
// v3: Session ACE -- evicts the briefly-deployed fake-checkerboard skyline PNGs; /brand/* is
// also stale-while-revalidate from v3 so an in-place asset regeneration propagates without
// another bump.
// v4: Session AFG -- forces every returning device to drop its old app-shell cache on this deploy,
// a clean slate for the reported engineer-PWA messaging/timesheet issue and the new engineer
// manifest. NB /api/* is network-only (never cached; see fetchStrategy.ts), so this cache never
// held an API response; the bump evicts only stale precached shell/asset copies.
export const APP_SHELL_CACHE = "ele-app-shell-v4";
// The offline-allow-listed API GET cache (the engineer diary, stale-while-revalidate). The diary is
// per-engineer, so the app clears this on login/logout to prevent one engineer seeing another's
// cached week on a shared device.
export const OFFLINE_API_CACHE = "ele-api-swr-v1";
